import {
    cloneDeep,
    merge,
} from 'lodash';
import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@saddlebackchurch/react-cm-ui/core/styles/withStyles';
import React from 'react';
import Chart from './chart.js';

const propTypes = {
    classes: PropTypes.shape({
        root: PropTypes.string,
    }),
    className: PropTypes.string,
    color1: PropTypes.string,
    color2: PropTypes.string,
    height: PropTypes.number,
    innerSize: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    options: PropTypes.shape({}),
    value1: PropTypes.number.isRequired, // TODO/FIXME: Come up with a better name!  Make it clear this one is the part that is filled in!
    value2: PropTypes.number.isRequired, // TODO/FIXME: Come up with a better name!  Make it clear this one is the part that is NOT filled in!
    width: PropTypes.number,
};

const defaultProps = {
    classes: undefined,
    className: undefined,
    color1: 'rgba(255,255,255,1)',
    color2: 'rgba(255,255,255,.25)',
    height: 65,
    innerSize: '60%',
    options: {},
    width: 65,
};

const style = ({
    root: {
        '& .highcharts-container': {
            left: -12,
            top: -8,
        },
    },
});

class DonutChart extends React.Component {
    constructor(props) {
        super(props);

        const p = this.calculatePercents(props);
        const { innerSize, options } = props;

        const newOptions = merge({}, {
            chart: {
                backgroundColor: 'transparent',
                height: props.height,
                margin: 0,
                spacing: 0,
                type: 'pie',
                width: props.width,
            },
            credits: {
                enabled: false,
            },
            legend: {
                enabled: false,
            },
            plotOptions: {
                pie: {
                    center: ['50%', '50%'],
                    shadow: false,
                },
            },
            series: [
                {
                    data: [
                        {
                            color: props.color1,
                            y: p[0],
                        },
                        {
                            color: props.color2,
                            y: p[1],
                        },
                    ],
                    dataLabels: {
                        enabled: false,
                    },
                    innerSize,
                    size: '100%',
                    states: {
                        hover: {
                            enabled: false,
                        },
                    },
                },
            ],
            subtitle: {
                text: '',
            },
            title: {
                text: '',
            },
            tooltip: {
                enabled: false,
            },
            yAxis: {
                title: {
                    text: '',
                },
            },
        }, options);

        this.state = { options: newOptions };
    }

    componentDidUpdate(prevProps) {
        const {
            value1,
            value2,
        } = this.props;

        const {
            options,
        } = this.state;

        if (value1 !== prevProps.value1 || value2 !== prevProps.value2) {
            const newOptions = cloneDeep(options);
            const p = this.calculatePercents(this.props);

            /* eslint-disable prefer-destructuring  */
            newOptions.series[0].data[0].y = p[0];
            newOptions.series[0].data[1].y = p[1];
            /* eslint-enable prefer-destructuring  */

            this.setState({ options: newOptions });
        }
    }

    calculatePercents(props) {
        let p1 = 0.0;
        const total = props.value1 + props.value2;

        if (total > 0) {
            p1 = (props.value1 / total) * 100;
        }

        const p2 = 100 - p1;

        return [p1, p2];
    }

    render() {
        const {
            classes,
            className,
        } = this.props;

        const { options } = this.state;

        const rootClasses = ClassNames(
            `donut-chart${className ? ` ${className}` : ''}`,
            classes.root,
        );

        return (
            <div className={rootClasses}>
                <Chart options={options} />
            </div>
        );
    }
}

DonutChart.propTypes = propTypes;
DonutChart.defaultProps = defaultProps;

export default withStyles(style)(DonutChart);
